import { SocialNetwork, WebComponents } from "@/interfaces";
import { useAccountSettings, useSocialCoachSession } from "@/utils";
import { useEffect, useMemo, useState } from "react";
import { PlayersServices } from "@/services";

export interface UserContextData {
  isPlayer: boolean;
  isCoach: boolean;
  isAssistantCoach: boolean;
  hasWritePermission: boolean;
  playerId?: number;
  coachId?: number;
  socialNetworks?: SocialNetwork[];
}

export const InitialUserContextData: UserContextData = {
  isPlayer: false,
  isCoach: false,
  isAssistantCoach: false,
  hasWritePermission: false,
  playerId: undefined,
  coachId: undefined,
  socialNetworks: undefined,
};

export const UserContext = (): UserContextData => {
  const { isPlayer, isCoach, isAssistantCoach, playerId, coachId } = useSocialCoachSession();
  const { hasWritePermission: checkPermission } = useAccountSettings();
  const hasWritePermission = useMemo(() => {
    return checkPermission(WebComponents.PLAYER_CARDS);
  }, [checkPermission]);
  const [socialNetworks, setSocialNetworks] = useState<SocialNetwork[]>([]);

  useEffect(() => {
    if (playerId) {
      PlayersServices.get(playerId).then(p => {
        setSocialNetworks(p.profile.socialNetworks || []);
      });
    }
  }, [playerId]);

  return {
    isPlayer,
    isCoach,
    isAssistantCoach,
    hasWritePermission,
    playerId,
    coachId,
    socialNetworks,
  };
};
